import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';

const { BOLD_BLACK } = colors;

const renderDaysHeaderStyle = makeStyles(() => ({
	dayHeader: {
		width: 350 / 10,
		height: 280 / 10,
		color: BOLD_BLACK,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		backgroundColor: 'white',
		fontSize: 12,
		fontWeight: 'bold',
		padding: 2,
		margin: 0.5,
	},
}));

export default renderDaysHeaderStyle;
